const isCompleteIsbn = (value) => {
  if (/^97[89]\d{10}$/.test(value)) {
    return (
      [...value].reduce(
        (sum, digit, index) => sum + Number(digit) * (index % 2 ? 3 : 1),
        0
      ) %
        10 ===
      0
    );
  }
  if (/^\d{9}[\dX]$/.test(value)) {
    return (
      [...value].reduce(
        (sum, digit, index) =>
          sum + (digit === 'X' ? 10 : Number(digit)) * (10 - index),
        0
      ) %
        11 ===
      0
    );
  }
  return false;
};

const normalizeBookIdentifierQuery = (query, fields, group) => {
  if (!query || 'string' !== typeof query.q) {
    return query;
  }

  const value = query.q.trim();
  if (!/^[\dXx\s-]+$/.test(value)) {
    return query;
  }

  const normalized = value.replace(/[\s-]/g, '').toUpperCase();
  if (group === 'search' && isCompleteIsbn(normalized)) {
    // Phrase search disables typo matches for a complete ISBN. Keep partial
    // identifiers and ordinary searches on the existing search path.
    query.q = `"${normalized}"`;
    query.attributesToSearchOn = [
      'isbn',
      'book_isbn',
      'sku',
      'book_sku',
      'global_unique_id',
    ];
  } else if (/^\d{8,}$/.test(normalized)) {
    query.q = normalized;
  }

  return query;
};

const registerBookIdentifierSearch = () => {
  const findstr = window.findstr;
  if (!findstr?.hooks || findstr.bookIdentifierSearchRegistered) {
    return;
  }
  findstr.bookIdentifierSearchRegistered = true;

  findstr.hooks.addFilter(
    'findstrBuildSearchQuery',
    'vtx-book-identifiers',
    normalizeBookIdentifierQuery,
    20
  );
  findstr.hooks.addFilter(
    'searchResults',
    'vtx-book-identifiers',
    (result, group, field, input, query) => {
      // The phrase syntax belongs to the engine, not to shared URLs or the
      // search form submitted with Enter.
      if (group === 'search' && /^"[\dX]+"$/.test(query.q || '')) {
        query.q = query.q.slice(1, -1);
      }
      return result;
    }
  );
};

if (window.findstr?.hooks) registerBookIdentifierSearch();
else document.addEventListener('findstrLoaded', registerBookIdentifierSearch);

export default normalizeBookIdentifierQuery;
